import React from "react";
import PropTypes from "prop-types";

import AddEditUserFields from "./AddEditUserFields";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import useAddUserDialogFields from "hooks/system/useAddUserDialogFields";

import {
  UPDATE_USER_MUTATION,
  GET_USERS_QUERY_NAME,
} from "graphqlQueries/system";

import editUserValidator from "validators/editUserValidator";

const fieldsWithPlaceForError = [
  "email",
  "username",
  "password",
  "first_name",
  "last_name",
  "groupname",
];

const EditUserDialog = (props) => {
  const { userInfo } = props;
  const { loading, roleNames } = useAddUserDialogFields(userInfo.isSuperuser);
  const initialValues = {
    email: userInfo.email,
    username: userInfo.userName,
    password: "",
    confirm_password: "",
    first_name: userInfo.firstName,
    last_name: userInfo.lastName,
    groupname: userInfo.groupName,
  };

  const dataMapper = (data) => {
    data.password === "" && delete data.password;
    userInfo.isSuperuser && delete data.groupname;
    return data;
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_USER_MUTATION}
      refetchQueries={[GET_USERS_QUERY_NAME]}
      dataMapper={dataMapper}
      initialValues={initialValues}
      validationSchema={editUserValidator(userInfo.isSuperuser)}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Edit user"
      submitButtonName="Save"
      className="dialog-default-width"
      disableSubmit={loading}
      {...props}
    >
      <AddEditUserFields
        loading={loading}
        roleNames={roleNames}
        isSuperuser={userInfo.isSuperuser}
        isEdit={true}
      />
    </DialogFormWithMutation>
  );
};

EditUserDialog.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditUserDialog;
